import { Vector3 } from "three";
import { ModelGhostPool } from "oc-jaco3d/arrangement/ModelGhostPool";
import { MyModelCutted } from "./MyModelCutted";
import { v3 } from "oc-threejs/short3";
import type { Jaco } from "oc-jaco3d/arrangement/Jaco";

interface ClippingParamters {
  size: Vector3;
  materialMap: any;
  fixGridPosition: Vector3;
  gehrung45: boolean;
  diagonalCutted: boolean;
  rotateBeforeCutting: number;
  diagonalCuttingprops: {
    left: boolean;
    top: number;
    bottom: number;
  };
}

export class MyModelGhostPool extends ModelGhostPool {
  constructor(arrangement: Jaco) {
    super(arrangement);
  }

  modelCreator(modelParameters: {
    modelMaterialRelation: any;
    clippingParameters: ClippingParamters;
    [key: string]: any;
  }): MyModelCutted {
    const model = new MyModelCutted(
      this as any /* hack: parent wird nachträglich gesetzt*/,
      modelParameters.modelMaterialRelation
    );
    Object.assign(model, modelParameters);
    return model;
  }

  defaultModelParameters(): {
    clippingParameters: ClippingParamters;
  } {
    return {
      clippingParameters: {
        size: v3(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
        materialMap: null,
        fixGridPosition: v3(0, 0, 0),
        gehrung45: false,
        diagonalCutted: false,
        rotateBeforeCutting: 0,
        diagonalCuttingprops: {
          left: false,
          top: Number.POSITIVE_INFINITY,
          bottom: Number.POSITIVE_INFINITY,
        },
      },
    };
  }
}
